/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeAggregationClauseDtoV2 = {
    kind: AsCodeAggregationClauseDtoV2.kind;
};

export namespace AsCodeAggregationClauseDtoV2 {

    export enum kind {
        AVERAGE = 'Average',
        NORMALIZED_AVERAGE = 'NormalizedAverage',
        COUNT_ALL_ROWS = 'CountAllRows',
        DISTINCT_COUNT = 'DistinctCount',
        SUM = 'Sum',
        MAX = 'Max',
        MIN = 'Min',
        QUANTILE = 'Quantile',
        STANDARD_DEVIATION = 'StandardDeviation',
        VARIANCE = 'Variance',
        CUSTOM_AGGREGATION = 'CustomAggregation',
    }


}
